import { render, staticRenderFns } from "./InvoiceEditForm.vue?vue&type=template&id=3b8fe4f8"
import script from "./InvoiceEditForm.vue?vue&type=script&lang=js"
export * from "./InvoiceEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports